import { jsx } from 'react/jsx-runtime';
import { Hub, BrowserClient } from '@sentry/browser';
import { useState } from 'react';
import { version } from '../env/environment.js';
import { isInBrowser } from '../utils/browserUtils.js';
import { useEnv } from './EnvProvider.js';
import ErrorContext from './ErrorContext.js';

const SentryProvider = ({ children }) => {
    const { sentryDsn, stage } = useEnv();
    const [hub] = useState((() => {
        const hub = new Hub(new BrowserClient({
            dsn: sentryDsn,
            environment: stage === 'prod' ? 'production' : 'development',
            release: version,
        }));
        hub.configureScope((scope) => {
            scope.setTags({ version: version, url: isInBrowser && window.location.href });
        });
        return hub;
    })());
    const [errorHandler] = useState({
        captureException: (error, action) => {
            const hint = action ? { data: { action } } : undefined;
            stage === 'prod' && hub.captureException(error, hint);
            stage !== 'prod' && console.error(error, hint);
            return error;
        },
    });
    return jsx(ErrorContext.Provider, { value: errorHandler, children: children });
};

export { SentryProvider as default };
//# sourceMappingURL=SentryProvider.js.map
